export enum TransactionChannel {
  App = 'APP',
  Campaign = 'CAMPAIGN',
  Mobile = 'MOBILE',
  PointsExpiration = 'POINTS_EXPIRATION',
  Quest = 'QUEST',
  Receipt = 'RECEIPT',
  Restaurant = 'RESTAURANT',
  Support = 'SUPPORT',
  ThirdParty = 'THIRD-PARTY',
  Web = 'WEB',
}
